import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IThirdPartyLOA } from '@ruby/modules/third-party/models/third-party.interface';
import { selectThirdPartyCoreState } from '@ruby/modules/third-party/store';
import { fromThirdPartyCore, ThirdPartyCoreActions } from '@ruby/modules/third-party/store/third-party-core.index';
import { IGridResultOptions } from '@ruby/shared/models/commons/grid.interface';

@Component({
  selector: 'ng-third-party-grid-container',
  template: `
    <div class="d-flex flex-column h-100">
      <ng-third-party-header-container grid-header></ng-third-party-header-container>
      <ng-third-party-grid
        *ngIf="(store$ | async) as store"
        [loaData]="store.loas"
        [loading]="store.loading"
        [companies]="companies"
        (refresh)="refresh()"
      >
      </ng-third-party-grid>
    </div>`,
  styleUrls: ['./third-grid.container.scss']
})
export class ThirdPartyGridContainerComponent implements OnInit {
  loading!: boolean;
  companies: Array<IGridResultOptions> = [];
  store$: Observable<fromThirdPartyCore.State>;

  constructor(private store: Store<fromThirdPartyCore.State>) {
    this.store$ = this.store.select(selectThirdPartyCoreState).pipe(
      tap((st: fromThirdPartyCore.State) => {
        const noDuplicatedCustomers = st.loas.filter(
          (value: IThirdPartyLOA, index: number, arrayCustomers: Array<IThirdPartyLOA>) =>
            arrayCustomers.findIndex((loa: IThirdPartyLOA) => (loa.companyEid === value.companyEid)) === index);
        const companyNames = new Set(noDuplicatedCustomers.map((item: IThirdPartyLOA) => item.companyName));
        this.companies = ['ALL', ...companyNames].map((item?: string, index?: number) => ({ id: index!, value: item! }));
      })
    );
  }

  ngOnInit(): void {
    this.store.dispatch(ThirdPartyCoreActions.loadLOA());
  }

  /**
   * Refresh
   *
   * @summary This method dispatch an action to refresh the grid
   * @return void
   */
  refresh(): void {
    this.store.dispatch(ThirdPartyCoreActions.loadLOA());
  }
}
